import { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import type { RequestProductsReport } from '@practium/features/api';
import styles from './PendingRequestsMonthlyChart.module.css';

interface PendingRequestsMonthlyChartProps {
	year: number;
	months: RequestProductsReport['pendingByMonth']['months'];
}

export const PendingRequestsMonthlyChart = ({ year, months }: PendingRequestsMonthlyChartProps) => {
	const [primaryColor, setPrimaryColor] = useState('#453af1');
	const [tickColor, setTickColor] = useState('#767676');
	const data = months.map(item => ({
		...item,
		label: new Intl.DateTimeFormat('pt-BR', { month: 'short', timeZone: 'UTC' })
			.format(new Date(Date.UTC(year, item.month - 1, 1)))
			.replace('.', ''),
	}));

	useEffect(() => {
		const style = getComputedStyle(document.documentElement);
		const primary = style.getPropertyValue('--primary').trim();
		const secondary = style.getPropertyValue('--text-secondary').trim();
		if (primary) setPrimaryColor(primary);
		if (secondary) setTickColor(secondary);
	}, []);

	return (
		<div className={styles.chart}>
			<ResponsiveContainer width="100%" height="100%">
				<BarChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
					<CartesianGrid vertical={false} stroke="var(--border)" strokeDasharray="3 3" />
					<XAxis dataKey="label" axisLine={false} tickLine={false} tick={{ fill: tickColor, fontSize: 11 }} />
					<Tooltip
						labelFormatter={label => `${label} ${year}`}
						formatter={value => [Number(value).toLocaleString('pt-BR'), 'Solicitações pendentes']}
						contentStyle={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border)', borderRadius: '0.5rem' }}
					/>
					<Bar dataKey="count" name="Solicitações pendentes" fill={primaryColor} radius={[4, 4, 0, 0]} maxBarSize={32} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};
